import type { ReactElement, ReactNode } from 'react';

import { cn } from '../lib/cn';

export interface TopBarProps {
  /** Slot esquerda (breadcrumb, title) */
  start?: ReactNode;
  /** Slot central (busca opcional) */
  center?: ReactNode;
  /** Slot direita (notif, avatar, workspace switcher) */
  end?: ReactNode;
  /** Slot mobile (hamburger toggle) */
  mobileNav?: ReactNode;
  className?: string;
}

export function TopBar({ start, center, end, mobileNav, className }: TopBarProps): ReactElement {
  return (
    <header
      style={{
        background: 'oklch(0.16 0.013 270 / 0.78)',
        backdropFilter: 'var(--trakd-blur-glass-strong)',
        WebkitBackdropFilter: 'var(--trakd-blur-glass-strong)',
      }}
      className={cn(
        'border-color-violet/10 shadow-trakd-card sticky top-0 z-30 flex h-16 items-center gap-4 border-b px-6',
        className,
      )}
    >
      {mobileNav ? <div className="relative lg:hidden">{mobileNav}</div> : null}
      {start ? (
        <div className="relative min-w-0 flex-1">{start}</div>
      ) : (
        <div className="relative flex-1" />
      )}
      {center ? <div className="relative hidden lg:block">{center}</div> : null}
      {end ? <div className="relative flex items-center gap-3">{end}</div> : null}
    </header>
  );
}
